import Icon from "@client/controls/Icon/component";
import { IconType } from "@common/declarations";
import * as React from "react";
import { type KnowledgeBase } from "../types";

type Props = {
  articleCategories: KnowledgeBase.Api.ArticleCategory[];
  articles: KnowledgeBase.Api.Article[];
  getCategoryArticlesCount: (category: KnowledgeBase.Api.ArticleCategory) => string;
  numberOfColumns: number;
  setActiveItemState: (newState: KnowledgeBase.View.ActiveItem | null) => void;
  style: React.CSSProperties;
};
const KnoledgeBaseCategoryTiles = (props: Props) => {
  const gridStyle = React.useMemo(
    () =>
      ({
        "--grid-template": Array.from({ length: props.numberOfColumns }, (_) => "1fr").join(" ")
      } as React.CSSProperties),
    [props.numberOfColumns]
  );

  return (
    <div className="knowledge_base_tiled_container">
      {props.articleCategories.length > 0 && (
        <div style={gridStyle} className="knowledge_base_tiled_categories_container">
          {props.articleCategories.map((category) => (
            <div
              style={props.style}
              className="category_tile"
              onClick={() => props.setActiveItemState({ type: "category", category: category })}
            >
              <h5 className="category_title">{category.name}</h5>
              {props.getCategoryArticlesCount(category)}
            </div>
          ))}
        </div>
      )}
      {props.articles.length > 0 && (
        <div style={props.style} className="knowledge_base_container">
          {props.articles.map((article) => (
            <div
              onClick={() => props.setActiveItemState({ type: "article", article: article })}
              className="article_title"
              key={article.articleId}
            >
              <Icon className="article_icon" iconClassName={IconType.Memo} />
              {article.title}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default KnoledgeBaseCategoryTiles;
